/**
 * printSampleLabel — print a small sample/tube label (number-only, no barcode).
 *
 * Mirrors printToken's hidden-iframe `window.print()`. The unique sample number
 * is the identity that ties the physical tube to its report; printing is
 * optional — the number can just be read off the screen. Sized for a 50×25mm
 * label roll.
 */

function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
}

function todayLabel() {
  return new Date().toLocaleDateString('en-IN', {
    timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function printSampleLabel({ sample_number, patient_name, test_name, specimen_type, queue_number }) {
  const html = `<!DOCTYPE html>
<html><head><meta charset="UTF-8"><style>
  @page { size: 50mm 25mm; margin: 2mm; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { width: 46mm; font-family: 'Courier New', Courier, monospace; color: #000; background: #fff; }
  .acc { font-size: 16px; font-weight: bold; letter-spacing: 1px; }
  .patient { font-size: 11px; font-weight: bold; margin-top: 1mm; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .test { font-size: 10px; margin-top: 0.5mm; }
  .meta { font-size: 8px; color: #333; margin-top: 0.5mm; }
</style></head>
<body>
  <div class="acc">${escapeHtml(sample_number || '—')}</div>
  <div class="patient">${escapeHtml(patient_name || 'Patient')}${queue_number != null ? ` &middot; #L-${escapeHtml(queue_number)}` : ''}</div>
  <div class="test">${escapeHtml(test_name || '')}${specimen_type ? ` &middot; ${escapeHtml(specimen_type)}` : ''}</div>
  <div class="meta">${escapeHtml(todayLabel())}</div>
</body></html>`;

  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:none;';
  document.body.appendChild(iframe);
  iframe.contentDocument.open();
  iframe.contentDocument.write(html);
  iframe.contentDocument.close();

  let printed = false;
  const doPrint = () => {
    if (printed) return;
    printed = true;
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => { if (document.body.contains(iframe)) document.body.removeChild(iframe); }, 1000);
  };
  iframe.onload = () => doPrint();
  setTimeout(() => doPrint(), 500);
}
